import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home.component';
import { ProjectComponent } from './pages/project.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: ':slug', component: ProjectComponent }
];
